import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import loadable from '@loadable/component';

import { isUserLoggedSelector } from 'common/selectors/user';
import {
  isWishListEnabledSelector,
  reactiveTemplateConfigSelector
} from 'common/selectors/theme';

import { addProductToWishlist } from 'common/actions/UserActions';
import { togglePageModal } from 'common/actions/PageActions';

const AddToWishlistButtonVariant = loadable(props =>
  import(`./${props.blockVariant}`)
);

class AddToWishlistButton extends PureComponent {
  render() {
    const {
      t,
      isEnabled = false,
      blockVariant,
      ...rest
    } = this.props;
    if (!isEnabled) {
      return null;
    }
    return (
      <AddToWishlistButtonVariant blockVariant={blockVariant} t={t} {...rest} />
    );
  }
}

const makeMapStateToProps = () => {
  const isUserLogged = isUserLoggedSelector();
  const isWishListEnabled = isWishListEnabledSelector();
  const reactiveTemplateConfig = reactiveTemplateConfigSelector(
    'AddToWishlistButtonVariant'
  );
  return (state, props) => {
    return {
      isLogged: isUserLogged(state, props),
      isEnabled: isWishListEnabled(state, props),
      blockVariant: reactiveTemplateConfig(state, props)
    };
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatchAddProductToWishlist: productId => {
      dispatch(addProductToWishlist(productId));
    },
    dispatchShowPageModal: modalId => {
      dispatch(togglePageModal(modalId, true));
    }
  };
};

const AddToWishlistButtonConnected = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(AddToWishlistButton);

export default withTranslation()(AddToWishlistButtonConnected);
